import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onefoudrseaterbusonrent() {



  const cardData = {
"keyword": "14 17 20 25 Seater Bus on Rent in Pune",

"headingDescription":
  "Aaradhya Travels provides 14, 17, 20, and 25 Seater Bus on Rent in Pune for family trips, weddings, corporate tours, school picnics, pilgrimage journeys, airport transfers, and outstation group travel. Our clean and comfortable AC buses with experienced drivers ensure safe, spacious, and affordable transportation for all group travel needs across Pune and Maharashtra.",

"topPlaces": [
{
"title": "Ellora Caves",
"description":
"Ellora Caves is a UNESCO World Heritage site near Aurangabad famous for rock-cut temples, sculptures, and ancient Indian architecture. It is a popular long-distance group travel destination from Pune for history and heritage tours."
},
{
"title": "Ajanta Caves",
"description":
"Ajanta Caves are UNESCO-listed Buddhist caves known for ancient paintings, carvings, and historical significance. It is a top cultural and heritage group tour destination from Pune."
},
{
"title": "Matheran",
"description":
"Matheran is Asia’s only automobile-free hill station known for viewpoints, toy train rides, and lush greenery. It is ideal for peaceful group trips from Pune."
},
{
"title": "Harihareshwar",
"description":
"Harihareshwar is a coastal pilgrimage and beach destination known as 'Dakshin Kashi'. It is popular for temple visits, beaches, and group tours from Pune."
},
{
"title": "Diveagar",
"description":
"Diveagar is a clean and less crowded beach destination known for coconut trees, calm waters, and peaceful group outings from Pune."
},
{
"title": "Bhandardara",
"description":
"Bhandardara is a scenic hill station known for Arthur Lake, Randha Falls, and beautiful monsoon views. It is a popular weekend group trip destination from Pune."
},
{
"title": "Amboli",
"description":
"Amboli is a hill station in the Sahyadri range famous for waterfalls, mist, and green valleys. It is ideal for nature and monsoon group tours from Pune."
},
{
"title": "Chiplun",
"description":
"Chiplun is a scenic Konkan town surrounded by rivers, greenery, and ghats. It is a popular long-road group travel destination from Pune."
},
{
"title": "Lavasa",
"description":
"Lavasa is a planned hill city known for lakeside promenade, colorful architecture, cafes, and leisure activities. It is a popular short group trip destination from Pune."
},
{
"title": "Karnala Bird Sanctuary",
"description":
"Karnala Bird Sanctuary is a protected forest area near Mumbai known for trekking, birdwatching, and nature trails. It is ideal for adventure group trips from Pune."
}
],



services: [
  {
    name: "14 17 20 25 Seater Bus Hire in Pune",
    description: "14 17 20 25 seater bus hire in Pune service provides spacious and comfortable transportation for family tours, corporate outings, wedding travel, school trips, airport transfers, and outstation journeys. Well-maintained buses ensure smooth highway travel suitable for short and long-distance group transportation requirements. Professional chauffeurs ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient seater bus reservations."
  },
  {
    name: "Pune to Shirdi 14 17 20 25 Seater Bus on Rent",
    description: "Pune to Shirdi 14 17 20 25 seater bus on rent service offers reliable transportation for Sai Baba darshan tours, pilgrimage travel, family trips, and spiritual journeys from Pune. Spacious seating and comfortable interiors ensure smooth highway travel suitable for devotees and senior citizens. Professional drivers provide safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Shirdi seater bus reservations."
  },
  {
    name: "Pune to Mahabaleshwar 14 17 20 25 Seater Bus on Rent",
    description: "Pune to Mahabaleshwar 14 17 20 25 seater bus on rent service provides comfortable transportation for hill station vacations, sightseeing tours, family outings, and corporate trips. Spacious buses ensure smooth ghat road journeys suitable for tourists and group travel. Professional chauffeurs provide safe driving and reliable transportation services throughout the Mahabaleshwar route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Mahabaleshwar bus reservations."
  },
  {
    name: "Pune to Goa 14 17 20 25 Seater Bus on Rent",
    description: "Pune to Goa 14 17 20 25 seater bus on rent service offers premium transportation for beach vacations, family holidays, corporate outings, bachelor trips, and tourist travel from Pune. Spacious buses with comfortable seating and luggage capacity ensure pleasant long-distance journeys for passengers. Professional chauffeurs ensure safe highway driving and reliable transportation services throughout the Goa route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Goa bus reservations."
  },
  {
    name: "Pune to Mumbai 14 17 20 25 Seater Bus on Rent",
    description: "Pune to Mumbai 14 17 20 25 seater bus on rent service provides dependable transportation for business travel, airport transfers, family tours, wedding events, and corporate journeys between Pune and Mumbai. Comfortable buses ensure smooth expressway travel suitable for group transportation needs. Professional drivers ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Mumbai bus reservations."
  },
  {
    name: "Pune to Ashtavinayak Darshan 14 17 20 25 Seater Bus on Rent",
    description: "Pune to Ashtavinayak Darshan 14 17 20 25 seater bus on rent service offers reliable transportation for devotees planning sacred Ganpati temple tours from Pune. Spacious buses ensure comfortable highway travel suitable for pilgrimage groups, families, and senior citizens. Professional chauffeurs ensure safe driving and dependable transportation services throughout the temple circuit journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Ashtavinayak bus reservations."
  },
  {
    name: "Pune to 5 Jyotirlinga 14 17 20 25 Seater Bus on Rent",
    description: "Pune to 5 Jyotirlinga 14 17 20 25 seater bus on rent service provides comfortable transportation for devotees visiting sacred Jyotirlinga temples across Maharashtra and nearby states. Spacious buses ensure smooth long-distance travel suitable for pilgrimage groups and family darshan tours. Professional drivers ensure safe highway driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Jyotirlinga bus reservations."
  },
  {
    name: "Pune to 5 Sadeteen Shaktipeeth 14 17 20 25 Seater Bus on Rent",
    description: "Pune to 5 Sadeteen Shaktipeeth 14 17 20 25 seater bus on rent service offers dependable transportation for spiritual journeys and temple darshan tours from Pune. Spacious buses ensure comfortable highway travel suitable for devotees, pilgrimage groups, and senior citizens. Professional chauffeurs ensure safe driving and smooth transportation services throughout the Shaktipeeth route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Shaktipeeth bus reservations."
  },
  {
    name: "Pune to Aurangabad 14 17 20 25 Seater Bus on Rent",
    description: "Pune to Aurangabad 14 17 20 25 seater bus on rent service provides reliable transportation for Ajanta Ellora tours, business travel, educational trips, and family vacations from Pune. Spacious seating and luggage capacity ensure comfortable long-distance journeys for tourists and group passengers. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Aurangabad route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Aurangabad bus reservations."
  },
  {
    name: "14 17 20 25 Seater Bus for Wedding Pune",
    description: "14 17 20 25 seater bus for wedding Pune service offers luxurious and spacious transportation for wedding guests, bridal parties, family members, and event travel requirements. Comfortable seating and premium interiors ensure smooth travel suitable for marriage ceremonies and celebrations. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the wedding schedule. Pickup services are available from homes, hotels, banquet halls, railway stations, and airport terminals across Pune. Flexible booking options allow convenient wedding bus reservations."
  },
  {
    name: "14 17 20 25 Seater Bus for Corporate Travel Pune",
    description: "14 17 20 25 seater bus for corporate travel Pune service provides professional transportation for office outings, employee travel, conferences, business meetings, industrial visits, and corporate events. Spacious buses ensure comfortable journeys suitable for executive teams and business passengers. Professional drivers ensure safe driving and punctual pickup services throughout the route. Pickup services are available from offices, IT parks, hotels, airports, and commercial areas across Pune. Flexible booking options allow convenient corporate bus reservations."
  },
  {
    name: "14 17 20 25 Seater Bus for School Picnic Pune",
    description: "14 17 20 25 seater bus for school picnic Pune service offers safe and comfortable transportation for educational tours, school outings, picnic trips, and student travel requirements. Spacious buses ensure smooth journeys suitable for children, teachers, and group travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the school trip route. Pickup services are available from schools, colleges, coaching institutes, homes, and educational campuses across Pune. Flexible booking options allow convenient school picnic bus reservations."
  },
  {
    name: "14 17 20 25 Seater Bus for Outstation Pune",
    description: "14 17 20 25 seater bus for outstation Pune service provides dependable long-distance transportation for family vacations, pilgrimage tours, business travel, sightseeing trips, and tourist journeys from Pune. Spacious buses ensure comfortable seating and smooth highway travel suitable for all passenger groups. Professional chauffeurs ensure safe driving and reliable transportation services across all major tourist destinations. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient outstation bus reservations."
  }
],

tableData: [
  ["14 17 20 25 Seater Bus Hire in Pune", "Pune to Shirdi 14 17 20 25 Seater Bus on Rent"],
  ["Pune to Mahabaleshwar 14 17 20 25 Seater Bus on Rent", "Pune to Goa 14 17 20 25 Seater Bus on Rent"],
  ["Pune to Mumbai 14 17 20 25 Seater Bus on Rent", "Pune to Ashtavinayak Darshan 14 17 20 25 Seater Bus on Rent"],
  ["Pune to 5 Jyotirlinga 14 17 20 25 Seater Bus on Rent", "Pune to 5 Sadeteen Shaktipeeth 14 17 20 25 Seater Bus on Rent"],
  ["Pune to Aurangabad 14 17 20 25 Seater Bus on Rent", "14 17 20 25 Seater Bus for Wedding Pune"],
  ["14 17 20 25 Seater Bus for Corporate Travel Pune", "14 17 20 25 Seater Bus for School Picnic Pune"],
  ["14 17 20 25 Seater Bus for Outstation Pune", "14 17 20 25 Seater Bus Hire in Pune"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable 14 17 20 25 Seater Bus on Rent in Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable 14, 17, 20, and 25 seater bus rental service in Pune with comfortable vehicles, professional drivers, and smooth travel arrangements for group tours and events."
      },
      {
        WhyChooseheading: "Affordable Seater Bus Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable 14 seater, 17 seater, 20 seater, and 25 seater bus rental packages with transparent pricing and flexible booking options without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Group Bus Booking Service",
        WhyChoosedescription: "Our seater bus rental service in Pune is available 24 hours for weddings, corporate travel, school trips, airport transfers, family tours, and outstation group travel requirements."
      },
      {
        WhyChooseheading: "Comfortable & Fully AC Buses",
        WhyChoosedescription: "All buses provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained for safe and comfortable group travel experiences."
      },
      {
        WhyChooseheading: "Flexible One Day & Outstation Tours",
        WhyChoosedescription: "Aaradhya Travels offers customized travel plans including one-day trips, weekend tours, multi-day outstation travel, pilgrimage journeys, and holiday packages."
      },
      {
        WhyChooseheading: "Multiple Seating Capacity Bus Options",
        WhyChoosedescription: "Customers can choose from 14 seater, 17 seater, 20 seater, and 25 seater buses suitable for corporate teams, school groups, tourists, wedding guests, and family travel."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune Locations",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Pune Airport, railway stations, hotels, homes, and major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Group Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local and outstation group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is 14 17 20 25 seater bus on rent in Pune?", answer: "14, 17, 20, and 25 seater bus rental service in Pune provides comfortable group transportation for tours, events, corporate travel, and family functions." },
    { question: "Is seater bus booking available 24 hours in Pune?", answer: "Yes, Aaradhya Travels provides 24/7 seater bus rental service in Pune." },
    { question: "Which seating capacity buses are available?", answer: "Aaradhya Travels offers 14 seater, 17 seater, 20 seater, and 25 seater buses for different group travel requirements." },
    { question: "Can I book buses for outstation travel?", answer: "Yes, customers can book buses for outstation tours, hill station trips, pilgrimage journeys, and holiday travel." },
    { question: "Do you provide buses for corporate events?", answer: "Yes, Aaradhya Travels provides bus rental services for corporate events, office outings, conferences, and employee transportation." },
    { question: "Are all buses air-conditioned?", answer: "Yes, all buses are fully air-conditioned and maintained for comfortable group travel." },
    { question: "Can I book bus rental service online in Pune?", answer: "Yes, customers can easily book bus rental service online or through phone booking." },
    { question: "Do you provide buses for weddings and family tours?", answer: "Yes, Aaradhya Travels provides spacious buses suitable for wedding transportation, family tours, and group travel." },
    { question: "Are bus rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for bus rental service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and festival travel periods." }
  ];

 const testimonials = [
  {
    id: 1,
    name: "Mr. Prashant More",
    feedback:
      "A 20 Seater Bus on rent in Pune was the perfect choice for our office team outing. Everyone traveled comfortably, and the vehicle arrived on time with all arrangements properly managed.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Shweta Bhosale",
    feedback:
      "We selected a 25 Seater Bus rental in Pune for a family gathering and the experience exceeded our expectations. The bus was clean, spacious, and made our journey convenient and stress-free.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "14, 17, 20, 25 Seater Bus on Rent in Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/14-17-20-25-seater-bus-on-rent-pune.jpg",
  "description": "Book 14, 17, 20, 25 Seater Bus on rent in Pune with Aaradhya Travels for family trips, corporate tours, weddings, pilgrimages, and outstation travel. Available for Shirdi, Mahabaleshwar, Goa, Mumbai, Ashtavinayak, Jyotirlinga, and Shaktipeeth tours.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4012"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/14-17-20-25-seater-bus-on-rent-in-pune"
  }
};






  return (
    <div>
<Helmet>
  <title>
    14, 17, 20, 25 Seater Bus on Rent in Pune | Group Travel Hire | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire 14, 17, 20, 25 Seater Bus on rent in Pune with Aaradhya Travels. Affordable buses available for Shirdi, Mahabaleshwar, Goa, Mumbai, Ashtavinayak darshan, Jyotirlinga tours, Shaktipeeth yatras, weddings, corporate trips, and family travel."
  />

  <meta
    name="keywords"
    content="14 17 20 25 seater bus Hire in Pune, Pune to Shirdi 14 17 20 25 Seater Bus on Rent, Pune to Mahabaleshwar 14 17 20 25 seater bus on rent, Pune to Goa 14 17 20 25 Seater Bus On Rent, Pune to Mumbai 14 17 20 25 Seater bus On Rent, Pune to Ashtavinayak darshan 14 17 20 25 seater bus on Rent, Pune to 5 Jyotirlinga 14 17 20 25 Seater bus on Rent, Pune to 5 Sadeteen Shaktipeeth 14 17 20 25 Seater"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/21.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onefoudrseaterbusonrent;